export const TITLE = 'Properties'
